import { SwitchFilled } from '@interhyp/platform-icons';
import _ from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import styles from "./DataGridHeaderCell.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DataGridHeaderCell = /*#__PURE__*/React.memo(({
  isFirst,
  isLast,
  isAlternating,
  isSticky,
  offsetTop,
  order,
  onOrder,
  column,
  align,
  isFixedRight,
  isLastButOne,
  hasBody,
  isOverflowing,
  nextButton,
  fullyScrolledLeft,
  headerBackgroundColor
}) => {
  const isSortable = !!column.sortFn || !!column.onSort;
  const [columnClicked, setColumnClicked] = useState('');
  useEffect(() => {
    if (column.onSort && columnClicked !== '') {
      column.onSort(columnClicked, order);
    }
  }, [column.name, order, column.onSort, column, columnClicked]);
  const handleClick = useCallback(() => {
    onOrder(column.name);
    setColumnClicked(column.name);
  }, [column.name, onOrder]);
  return /*#__PURE__*/_jsxs("div", {
    className: _(styles.dataGridHeaderCell, styles[align], {
      [styles.isAlternating]: isAlternating,
      [styles.isFirst]: isFirst,
      [styles.isLast]: isLast,
      [styles.isSortable]: isSortable,
      [styles.isSticky]: isSticky,
      [styles.isFixedRight]: isFixedRight,
      [styles.isLastButOne]: isLastButOne,
      [styles.hasBody]: hasBody,
      [styles.isOverflowing]: isOverflowing,
      [styles.fullyScrolledLeft]: fullyScrolledLeft
    }),
    style: {
      top: `${offsetTop}px`,
      backgroundColor: headerBackgroundColor
    },
    children: [isFixedRight && !isLast && nextButton || isFixedRight && isLast && !hasBody && nextButton, /*#__PURE__*/_jsx("div", {
      className: styles.content,
      onClick: isSortable ? handleClick : undefined,
      children: typeof column.header === 'function' ? column.header() : /*#__PURE__*/_jsx("b", {
        children: column.header
      })
    }), isSortable && /*#__PURE__*/_jsx("div", {
      className: styles.order,
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(SwitchFilled, {
        size: "SMALL",
        className: _({
          [styles.asc]: order === 'asc',
          [styles.desc]: order === 'desc'
        })
      })
    })]
  });
});